import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default () => ({
  winesSubmenuOpen: false,
  isTop: false,
  themeColor: 'dark',
  init() {
    this.elSections = document.querySelectorAll('[data-section-theme]');

    window.addEventListener('scroll', () => {
      this.isTop = window.scrollY === 0;
    });

    this.elSections.forEach((section) => {
      ScrollTrigger.matchMedia({
        // Mobile
        '(max-width: 1023px)': () => {
          ScrollTrigger.create({
            trigger: section,
            start: 'top-=24 top',
            onEnter: () => this.handleChangeColor(section),
            onEnterBack: () => this.handleChangeColor(section),
            markers: false
          });
        },

        // Desktop
        '(min-width: 1024px)': () => {
          ScrollTrigger.create({
            trigger: section,
            start: 'top-=40 top',
            onEnter: () => this.handleChangeColor(section),
            onEnterBack: () => this.handleChangeColor(section),
            markers: false
          });
        }
      });
    });

    window.scrollTo(window.scrollX, window.scrollY + 1);

    // TO DO find a better solution...
    setTimeout(() => {
      window.scrollTo(window.scrollX, window.scrollY - 1);
      ScrollTrigger.refresh();
    }, 10);
  },
  handleChangeColor(section) {
    const elHeader = document.querySelector('#site-header');
    const color = section.getAttribute('data-section-theme');
    elHeader.setAttribute('data-theme-color', color);
    this.themeColor = color;
  },
  handleFocusOut(e) {
    const submenu = this.$refs.winesSubmenu;
    if (e.target.classList.contains('last-link') && !submenu.contains(e.relatedTarget)) {
      this.winesSubmenuOpen = false;
    }
  }
});
